<script>
  import resources from './resources'

  export default {
    name: 'gadget-next-patient',
    mixins: [resources]
  }
</script>

<template lang="pug">
  section.gadget-proximo-paciente.white-bg.wrapper.full-width.gadget
    div(v-if="schedule.id")
      .gadget-title
        | Paciente Agendado
      .actions
        span.icon 
        ul
          li.exclude Remover
          li.half-width Lado a Lado
          li.full-width Tela Inteira
      div
        .col-xs-12.col-md-6
          label.light-red Nome
          h2.medium-gray {{ schedule.patient }}
        .col-xs-12.col-sm-6.col-md-3
          label.light-red Data
          h2.medium-gray {{ schedule.date }}
        .col-xs-12.col-sm-6.col-md-3
          label.light-red Horário
          h2.medium-gray.is-late {{ schedule.time }}
      .clearfix
      div
        .col-xs-12.col-md-6
          label.light-red Convênio
          h3.medium-gray {{ schedule.covenant }}
        .half-width-margin
        .col-xs-12.col-md-6
          label.light-red Empresa
          h3.medium-gray {{ schedule.company }}
</template>



// WEBPACK FOOTER //
// src/app/team/dashboard/gadget/components/next-patient/next-patient.vue